import { useState } from 'react';
import loadable from '@loadable/component';
import classNames from 'classnames';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import {
    ClickElement,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';
import { InfoIcon, PureButton } from '@jsmdg/yoshi';
import { type ProductDetailContext } from '../../types/types';
import styles from './FriendsDiscountBadge.module.scss';

const LoadableFriendsDiscountModal = loadable(
    async () => import('../FriendsDiscountModal/FriendsDiscountModal'),
);

async function trackBadgeClick(clickText: string): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickButton,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            click_element: ClickElement.BuddyVoucherInfo,
            click_text: clickText,
        },
    });
}

type FriendsDiscountBadgeProps = {
    readonly className?: string;
    readonly isSolid?: boolean;
};

const FriendsDiscountBadge = ({
    className,
    isSolid = false,
}: FriendsDiscountBadgeProps): JSX.Element => {
    const [showModal, setShowModal] = useState(false);
    const { isMydays, tenantConfig } = useFragmentContext<ProductDetailContext>();
    const badgeText = tenantConfig.friendsRabattText;

    const toggleModal = (): void => {
        setShowModal(!showModal);
        if (!showModal) {
            void trackBadgeClick(badgeText);
        }
    };

    return (
        <>
            {showModal && <LoadableFriendsDiscountModal onRequestClose={toggleModal} />}
            <PureButton
                className={classNames('d-flex', className, styles.badgeContainer, {
                    [styles.solid]: isSolid,
                })}
                onClick={toggleModal}
            >
                <div
                    className={classNames(
                        'd-flex align-items-center pr-0-5x pl-1x py-0x',
                        styles.badgeTextContainer,
                    )}
                >
                    <div className={classNames('font-complementary mr-0-5x', styles.badgeText)}>
                        {badgeText}
                    </div>
                    <div className={classNames('d-flex align-items-center', styles.badgeIcon)}>
                        <InfoIcon color={isSolid && isMydays ? undefined : '#000000'} size={27} />
                    </div>
                </div>
            </PureButton>
        </>
    );
};

export { FriendsDiscountBadge };
